/**
 * 🏗 Moves a certain column to a new position
 * @param evt 
 * @param headers 
 */
export function sortTheHeadersAndUpdateTheKey(evt: any, headers: any[]) {
  const headersTmp = headers;
  const oldIndex = evt.oldIndex;
  const newIndex = evt.newIndex;
  if (newIndex >= headersTmp.length) {
    let k = newIndex - headersTmp.length + 1;
    while (k--) {
      headersTmp.push(undefined);
    }
  }
  headersTmp.splice(newIndex, 0, headersTmp.splice(oldIndex, 1)[0]);
}